export default "HR,Høyesterett\nLR,Lagmannsrett\nTR,Tingrett\nJR,Jordskifterett\n"